import Search from 'components/commons/search'
import { useState } from 'react'
import { capitalize } from 'utils/utils'
import clsx from 'clsx'
import { useClickOutside } from 'hooks/useClickOutside'
import icCloseRoundRed from 'assets/images/ic-close-round-red.svg'

const MultipleSelect = ({
    className,
    optionsClassName,
    selectedClassName,
    name,
    options,
    value = [],
    onSearch,
    onChange,
    placeholder,
}) => {
    const [showOptions, setShowOptions] = useState(false)
    const [keyword, setKeyword] = useState('')

    const isNotExistSelectedItem = (item) => {
        return !value?.find((i) => i?.label === item?.label)
    }

    const onSelect = (selectedItem) => {
        setShowOptions(false)
        if (onSearch) setKeyword('')
        if (isNotExistSelectedItem(selectedItem)) onChange({ name, value: [...value, selectedItem] })
    }

    const onSearchHandler = (keyword) => {
        if (onSearch) onSearch(keyword)
        setKeyword(keyword)
        setShowOptions(true)
    }

    const onDelete = (item) => {
        const filterSelected = value?.filter((i) => i?.label !== item?.label)
        onChange({ name, value: filterSelected })
    }

    useClickOutside({
        callback: () => setShowOptions(false),
        elementID: `multiple-select-${name}`,
    })

    return (
        <div id={`multiple-select-${name}`} className={clsx('relative', className)}>
            <Search value={keyword} onSearch={onSearchHandler} placeholder={placeholder} />
            <div
                className={clsx(
                    'w-[90%] flex flex-col mx-8 space-y-2 -mt-1 border rounded-lg z-30 bg-white absolute max-h-36 overflow-auto',
                    optionsClassName,
                    showOptions ? 'block' : 'hidden',
                )}
            >
                {options?.length ? (
                    options?.map((item, index) => (
                        <div
                            key={index}
                            className={'capitalize text-[#2B2B2B] p-2 hover:bg-[#F2F7FF] cursor-pointer'}
                            onClick={() => onSelect(item)}
                        >
                            {item?.label}
                        </div>
                    ))
                ) : (
                    <div className={'p-2'}>Not Found</div>
                )}
            </div>
            <div
                className={clsx(
                    'flex flex-col -mt-2 border-x border-b rounded-b-lg max-h-56',
                    selectedClassName,
                    value?.length ? 'block' : 'hidden',
                )}
            >
                <div className={'space-y-4 p-4 mt-2 overflow-auto'}>
                    {value?.map((item, index) => (
                        <div key={index} className={'flex items-center justify-between'}>
                            <div className={'flex items-center space-x-2'}>
                                {item?.image_url && <img src={item?.image_url} alt={'image'} className={'w-8 h-8'} />}
                                <p>{capitalize(item?.label)}</p>
                            </div>
                            <img
                                src={icCloseRoundRed}
                                alt={'ic-close-rounded-red'}
                                className={'w-6 h-6 cursor-pointer'}
                                onClick={() => onDelete(item)}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default MultipleSelect
